// ref: http://www.lingoes.net/en/translator/langcode.htm

export const LOCALES = {
  VIETNAMESE: {
    code: "vi-VN",
    shortCode: "vi",
    description: "TIẾNG VIỆT"
  },
  ENGLISH: {
    code: "en-US",
    shortCode: "en",
    description: "ENGLISH"
  }
};

export const languageByCode = (code) => {
  for (const [key, value] of Object.entries(LOCALES)) {
    if (value.code === code) return key;
  }
  return Object.keys(LOCALES)[0];
};
